/**
 * 检查当前代码是否在store中运行
 * @returns 是否在store中
 */
export function checkIsInStore() {
  let isInStore = false;
  try {
    // 存在document则说明不在store中
    isInStore = !document;
  } catch {
    isInStore = true;
  }
  return isInStore;
}

/** 是否 LiteApp 开发者工具环境 */
export function isLiteAppDevtool(): boolean {
  const platform = lite.system?.getSystemInfo?.()?.platform;
  return platform?.includes('devtool') ?? false;
}
